import React from 'react';
import {
  HiOutlineArrowTrendingUp,
  HiOutlineCheckCircle,
  HiOutlineDocumentPlus,
  HiOutlineDocumentText,
  HiOutlineFolder,
  HiOutlinePencilSquare,
  HiOutlineSparkles,
} from 'react-icons/hi2';
import { Link } from 'react-router-dom';
import PageHeader from './ui/PageHeader';

const stats = [
  {
    title: 'Blog Categories',
    value: '70',
    trend: '+12% from last month',
    tone: 'primary',
    icon: HiOutlineFolder,
    href: '/dashboard/blog-category-list',
  },
  {
    title: 'Published Blogs',
    value: '343',
    trend: '28 updated recently',
    tone: 'success',
    icon: HiOutlineDocumentText,
    href: '/dashboard/blog-list',
  },
  {
    title: 'Draft Velocity',
    value: '18',
    trend: 'ready for editorial review',
    tone: 'warning',
    icon: HiOutlinePencilSquare,
    href: '/dashboard/blog',
  },
  {
    title: 'Content Health',
    value: '94%',
    trend: 'metadata coverage',
    tone: 'info',
    icon: HiOutlineCheckCircle,
    href: '/dashboard/blog-list',
  },
];

const quickActions = [
  {
    title: 'Create a blog post',
    description: 'Start a new article with metadata, category, cover image, and rich content.',
    icon: HiOutlineDocumentPlus,
    href: '/dashboard/blog',
  },
  {
    title: 'Add a category',
    description: 'Group content with a visual category and clean slug generation from the API.',
    icon: HiOutlineFolder,
    href: '/dashboard/blog-category',
  },
];

const activity = [
  'Review category images for consistent ratios.',
  'Refresh older blog meta descriptions.',
  'Check top performing slugs before the next campaign.',
];

const BusinessAnalysis = () => {
  return (
    <section className="page-stack">
      <PageHeader
        eyebrow="Overview"
        title="Dashboard"
        description="A cleaner command center for publishing, organizing, and reviewing Event Planet content."
        actions={
          <Link to="/dashboard/blog" className="btn btn-primary">
            <HiOutlineDocumentPlus aria-hidden="true" />
            New Blog
          </Link>
        }
      />

      <div className="row g-4">
        {stats.map((stat) => {
          const Icon = stat.icon;

          return (
            <div className="col-12 col-sm-6 col-xl-3" key={stat.title}>
              <Link className={`stat-card stat-card-${stat.tone}`} to={stat.href}>
                <span className="stat-icon">
                  <Icon aria-hidden="true" />
                </span>
                <span className="stat-label">{stat.title}</span>
                <strong>{stat.value}</strong>
                <small>
                  <HiOutlineArrowTrendingUp aria-hidden="true" />
                  {stat.trend}
                </small>
              </Link>
            </div>
          );
        })}
      </div>

      <div className="row g-4">
        <div className="col-12 col-xl-8">
          <div className="surface-card h-100">
            <div className="section-heading">
              <div>
                <span className="section-kicker">Workflow</span>
                <h2>Quick actions</h2>
              </div>
            </div>

            <div className="row g-3">
              {quickActions.map((action) => {
                const Icon = action.icon;

                return (
                  <div className="col-12 col-md-6" key={action.title}>
                    <Link className="quick-action" to={action.href}>
                      <span>
                        <Icon aria-hidden="true" />
                      </span>
                      <strong>{action.title}</strong>
                      <p>{action.description}</p>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="col-12 col-xl-4">
          <div className="surface-card h-100">
            <div className="section-heading">
              <div>
                <span className="section-kicker">Content QA</span>
                <h2>Today&apos;s focus</h2>
              </div>
              <span className="soft-icon">
                <HiOutlineSparkles aria-hidden="true" />
              </span>
            </div>

            <ul className="check-list">
              {activity.map((item) => (
                <li key={item}>
                  <HiOutlineCheckCircle aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessAnalysis;
